const { useConfigureInstall } = require('./src/shared/UseInstall')

exports.onClientEntry = () => {
  useConfigureInstall()
}
